<script>
  import EditView from '../base/EditView.vue'
  import FormInput from '../form/form-input.vue'

  export default {
    components: {
      EditView,
      FormInput,
    },
  }
</script>
<template>
  <edit-view store="customer" list-route="CustomerList" v-slot:default="slotProps">
    <form-input :store="slotProps.store" prop-name="addr1" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="addr2" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="addr3" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="addr4" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="email" type="email" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="vatId" class="col-3"></form-input>
  </edit-view>
</template>

